import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
  public isInitialized = false;

  constructor() { }
}
